// Lesson 2 — Your first run. The learner holds 3+4 of Characters (a run needing
// a 2 or 5) surrounded by other connectable tiles, plus a lone White Dragon that
// can never join a run. The taught move is discarding that useless honour.

import { createDealBuilder, fillerBot } from './deckBuilder.js';
import type { LessonScript } from '../types.js';

const b = createDealBuilder();

const man3 = b.suit('man', 3);
const man4 = b.suit('man', 4);
const white = b.honor('white');

const human = [
  man3,
  man4,
  b.suit('pin', 4),
  b.suit('pin', 5),
  b.suit('sou', 6),
  b.suit('sou', 7),
  b.suit('man', 6),
  b.suit('man', 7),
  b.suit('pin', 2),
  b.suit('sou', 2),
  b.suit('sou', 9),
  b.honor('red'),
  white,
];

const seat1 = fillerBot(b, 'east', [['pin', 1], ['pin', 4], ['sou', 4], ['man', 1]]);
const seat2 = fillerBot(b, 'south', [['man', 5], ['pin', 7], ['sou', 1], ['sou', 6]]);
const seat3 = fillerBot(b, 'north', [['pin', 3], ['man', 7], ['sou', 3], ['pin', 6]]);

const wall = [
  b.suit('man', 1),
  b.suit('pin', 5),
  b.suit('sou', 5),
  b.suit('man', 5),
  b.suit('pin', 2),
  b.suit('sou', 8),
];

export const lesson2FirstRun: LessonScript = {
  id: 'lesson-2-first-run',
  titleKey: 'lesson.script.firstRun.title',
  deal: { hands: [human, seat1, seat2, seat3], wall },
  steps: [
    {
      instructionKey: 'lesson.script.firstRun.intro',
      expectedAction: { kind: 'info' },
      highlightTileIds: [man3.id, man4.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.firstRun.discard',
      expectedAction: { kind: 'discard', tileId: white.id },
      highlightTileIds: [white.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.firstRun.done', expectedAction: { kind: 'info' }, autoAdvance: false },
  ],
};
